import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import lock from "../assets/img/lock.png";
import profile from "../assets/img/profile.png";
import phone from "../assets/img/Vector.png";
import cal from "../assets/img/calendar.png";
import people from "../assets/img/people.png";
import mail from "../assets/img/sms.svg";
import dolar from "../assets/img/dollar-circle.png";
import clock from "../assets/img/clock.png";
import helpIcon from "../assets/img/Help-icon.png";
import viewIcon from "../assets/img/eye.png";
import hideIcon from "../assets/img/invisible.png";

import AuthService from "../services/auth.service";
import Header from "components/Header/Header";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert-info" role="alert">
        This field is required!
      </div>
    );
  }
};

const Signup = () => {
  const [showPassword, setShowPassword] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [vpassword, setVpassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [depositAmount, setDepositAmount] = useState("");
  const [duration, setDuration] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [gender, setGender] = useState("");
  const [personalItem, setPersonalItem] = useState("");
  const [affiliation, setAffiliation] = useState("");
  const [successful, setSuccessful] = useState(false);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  let navigate = useNavigate();
  const formSignUp = useRef();
  const checkBtn = useRef();

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const onChangeFirstName = (e) => {
    setFirstName(e.target.value);
  };

  const onChangeLastName = (e) => {
    setLastName(e.target.value);
  };

  const onChangeDOB = (e) => {
    setDateOfBirth(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const onChangeVpassword = (e) => {
    setVpassword(e.target.value);
  };

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };
  const onChangeMobile = (e) => {
    setMobileNumber(e.target.value);
  };

  const onChangeGender = (e) => {
    setGender(e.target.value);
  };
  const onChangeAffiliation = (e) => {
    setAffiliation(e.target.value);
  };
  const onChangeDepositAmount = (e) => {
    setDepositAmount(e.target.value);
  };
  const onChangeDuration = (e) => {
    setDuration(e.target.value);
  };
  const onChangeServiceType = (e) => {
    setServiceType(e.target.value);
  };
  const onChangePersonalItem = (e) => {
    setPersonalItem(e.target.value);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(false);

    formSignUp.current.validateAll();

    if (password !== vpassword) {
      setMessage("Passwords do not match.");
      return;
    }
    try {
      // Create FormData object if we have an image
      let formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("dateOfBirth", dateOfBirth);
      formData.append("mobileNumber", mobileNumber);
      formData.append("gender", gender);
      formData.append("affiliation", affiliation);
      formData.append("depositAmount", depositAmount);
      formData.append("duration", duration);
      formData.append("serviceType", serviceType);
      formData.append("personalItem", personalItem);

      if (image) {
        formData.append("profileImage", image);
      }

      // Proceed with form submission
      if (checkBtn.current.context._errors.length === 0) {
        const response = await AuthService.register(formData);
        setMessage(response.data.message);
        setSuccessful(true);
        // Delay the navigation for 2 seconds
        setTimeout(() => {}, 2000);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      const resMessage =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      setLoading(false);
      setMessage(resMessage);
    }
  };

  return (
    <>
      <Header />
      <div className="homeSection">
        <div className="homeSection-content">
          <div className="wrapper-login">
            <Form
              onSubmit={handleSignUp}
              ref={formSignUp}
              className="signup-form"
            >
              <div className="container">
                <div className="navv">Sign Up</div>
              </div>
              <div className="inputs-1">
                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={mail} />{" "}
                  </i>
                  <Input
                    type="text"
                    className="input-control"
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={onChangeEmail}
                    validations={[required]}
                  />
                </div>
                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={profile} />{" "}
                  </i>
                  <Input
                    type="text"
                    className="input-control"
                    name="firstName"
                    placeholder="First Name"
                    value={firstName}
                    onChange={onChangeFirstName}
                    validations={[required]}
                  />
                </div>

                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={profile} />{" "}
                  </i>
                  <Input
                    type="text"
                    className="input-control"
                    name="lastName"
                    placeholder="Last Name"
                    value={lastName}
                    onChange={onChangeLastName}
                    validations={[required]}
                  />
                </div>

                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={phone} />{" "}
                  </i>
                  <Input
                    type="text"
                    className="input-control"
                    name="Phone"
                    placeholder="Phone"
                    value={mobileNumber}
                    onChange={onChangeMobile}
                    validations={[required]}
                  />
                </div>

                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={people} />{" "}
                  </i>
                  <select
                    id="gender"
                    name="gender"
                    value={gender}
                    className="input-control"
                    onChange={onChangeGender}
                  >
                    <option value="" disabled hidden>
                      Gender
                    </option>
                    <option value="male" className="jag-input">
                      Male
                    </option>
                    <option value="female" className="jag-input">
                      Female
                    </option>
                    <option value="Prefer not to say" className="jag-input">
                      Prefer not to say
                    </option>
                  </select>
                </div>

                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={profile} />{" "}
                  </i>
                  <select
                    id="affiliation"
                    name="affiliation"
                    value={affiliation}
                    className="input-control"
                    onChange={onChangeAffiliation}
                  >
                    <option value="" disabled hidden>
                      Affiliation with authorities
                    </option>
                    <option value="Yes" className="jag-input">
                      Yes
                    </option>
                    <option value="No" className="jag-input">
                      No
                    </option>
                  </select>
                </div>
                <label>Date Of Birth</label>
                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={cal} />{" "}
                  </i>
                  <Input
                    type="date"
                    className="input-control"
                    name="dateOfBirth"
                    placeholder=""
                    value={dateOfBirth}
                    onChange={onChangeDOB}
                    validations={[required]}
                  />
                </div>

                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={dolar} />{" "}
                  </i>
                  <Input
                    type="text"
                    className="input-control"
                    name="depositAmount"
                    placeholder="Enter Deposit Amount"
                    value={depositAmount}
                    onChange={onChangeDepositAmount}
                    validations={[required]}
                  />
                </div>

                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={clock} />{" "}
                  </i>
                  <Input
                    type="text"
                    className="input-control"
                    name="duration"
                    placeholder="Duration (minutes)"
                    value={duration}
                    onChange={onChangeDuration}
                    validations={[required]}
                  />
                </div>

                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={lock} />{" "}
                  </i>
                  <select
                    id="serviceType"
                    name="serviceType"
                    value={serviceType}
                    className="input-control"
                    onChange={onChangeServiceType}
                  >
                    <option value="" disabled hidden>
                      Service Type
                    </option>
                    <option value="Massage" className="jag-input">
                      Massage
                    </option>
                    <option value="Escort" className="jag-input">
                      Escort
                    </option>
                    <option value="Full Service" className="jag-input">
                      Full Service
                    </option>
                  </select>
                </div>

                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={lock} />{" "}
                  </i>
                  <select
                    id="personalItem"
                    name="personalItem"
                    value={personalItem}
                    className="input-control"
                    onChange={onChangePersonalItem}
                  >
                    <option value="" disabled hidden>
                      Personal Items
                    </option>
                    <option value="Yes" className="jag-input">
                      Yes
                    </option>
                    <option value="No" className="jag-input">
                      No
                    </option>
                  </select>
                </div>
                
                  
                  {/* Add this after one of your existing fields */}
                  <label>Profile Picture</label>
                  <div className="input-feild-1">
                    {imagePreview ? (
                      <div style={{ marginBottom: "10px" }}>
                        <img
                          src={imagePreview}
                          alt="Preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            setImage(null);
                            setImagePreview(null);
                          }}
                          style={{ marginLeft: "10px" }}
                        >
                          Remove
                        </button>
                      </div>
                    ) : null}

                    <div style={{ display: "flex", gap: "10px" }}>
                      <label
                        htmlFor="file-upload"
                        style={{
                          padding: "8px 12px",
                          backgroundColor: "#f0f0f0",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Choose from Gallery
                      </label>
                      <input
                        id="file-upload"
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                      />

                     
                    </div>
                  </div>

                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={lock} />{" "}
                  </i>
                  <Input
                    type="password"
                    className="input-control"
                    name="password"
                    placeholder="Password"
                    value={password}
                    onChange={onChangePassword}
                    validations={[required]}
                  />
                </div>
                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={lock} />{" "}
                  </i>
                  <Input
                    type="password"
                    className="input-control"
                    name="vpassword"
                    placeholder="Re-type Password"
                    value={vpassword}
                    onChange={onChangeVpassword}
                    validations={[required]}
                  />
                </div>
                <div className="checkbox-1 forR">
                  <span className="box-1 bbox">
                 <p >By clicking "Continue", you agree to the Terms.For more information about how we process your personal data, please see our Privacy Policy
                 </p>
                  </span>
                </div>
                <div className="button-div-1 packem">
                  <button className="loginbutton-1" disabled={loading}>
                    {loading && (
                      <span className="spinner-border spinner-border-sm"></span>
                    )}
                    <span>Create Account</span>
                  </button>
                </div>
              </div>
              <div className="checkbox-1 forR">
                <span className="box-1 bbox">
                Already have an account?  
                  <a href="/">
                    <span className="ctaa"> Sign In</span>
                  </a>
                </span>
              </div>

              {message && (
                <div className="form-group">
                  <div className="alert-info" role="alert">
                    {message}
                  </div>
                </div>
              )}
              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
